import { useEffect, useState } from "react";
import "../../css/diActiveProfile.css";
import profileImg from "../../assets/images/shreepuram_vijay_prateek.png";
import success from "../../assets/images/badge/Success.png";
import { toast } from "react-toastify";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { logout } from "../../utils/auth";

export default function DeactiveModel({ onClose }) {
  const [isActive, setIsActive] = useState(1);
  const [password, setPassword] = useState("");
  const [isError, setIsError] = useState("");
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success("Please log in again to activate your account");
    navigate("/login");
  };
    
  const handleContinue = async () => {
    try {
      if (!password.trim()) {
        setIsError("Password is required");
        toast.error("Password is required");
        return;
      }
      const res = await api.post(
        `user/deactivate`,
        { password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (res?.status === 200 || res?.status === true) {
        setIsActive(3);
        toast.success("Account deactivated successfully");
        setTimeout(() => {
          handleLogout();
        }, 5000);
      } else {
        toast.error("Failed to deactivate account");
      }
    } catch (error) {
      console.log("Something went wrong", error);
      toast.error(error.response.data?.error || "Server error");
    }
  };

  useEffect(() => {
    if (isActive === 3) {
      setTimeout(() => {
        onClose();
      }, 3000);
    }
  }, [isActive]);

  return (
    <div className="deactive_modal_overlay">
      <div className="deactive_model_container">
        <button className="close_btn" onClick={onClose}>
          ✖
        </button>

        {isActive === 1 && (
          <>
            <div className="deactive_model_title">
              <h2>Are you sure?</h2>
              <h2>Deactivate your account</h2>
            </div>
            <div className="deactive_model_button">
              <button className="cancel_btn" onClick={onClose}>
                Cancel
              </button>
              <button onClick={() => setIsActive(2)} className="continue_btn">
                Continue
              </button>
            </div>
          </>
        )}

        {isActive === 2 && (
          <div className="deactivate_profile_container">
            <div className="deactivate_profile_section">
              <img src={profileImg} alt="Profile" />
              <p>for your security please re enter your password to continue</p>
            </div>
            <div className="deactive_model_input">
              <input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
              />
            </div>
            <div className="deactive_model_button">
              <button 
              onClick={() => handleContinue()}
              className="continue_btn">
                Continue
              </button>
            </div>
          </div>
        )}

        {isActive === 3 && (
          <div className="deactive_model_success">
            <img src={success} alt="Success" />
            <h2>Your account has been deactivated</h2>
          </div>
        )}
      </div>
    </div>
  );
}
